export default __webpack_public_path__ + "static/article-replace-or-repair-fe916714c24b0cde12842d9b8eee4b0e.jpg";